
function FooterAdsens() {
  return (
    <div id="foremediaads-footer"></div>

  )
}

export default FooterAdsens
